import apiServiceCall from "../services/ApiServiceCall";

export const getAlcaldias = () => {
    return apiServiceCall().get('/vui/frontend/alcaldias').then(({ data }) => data);
}

export const getAlcaldiaTramites = (institutionId) => {
    return apiServiceCall().get(`/alcaldias/${institutionId}/tramites`).then(({ data }) => data);
}
